<template>
    <div class="rental-list">
        <heading title="Project Rentals" tag="rental-list-title"/>
        <data-table ref="dataTable"
                    persist-name="rental-filter"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key === 'actions'" class="action-buttons d-flex">
                    <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                            v-if="slotProps.row.item.status === 'UNAPPROVED'"
                            v-on:click="approve(slotProps.row.item)">
                        Approve for Project
                    </button>
                    <button class="btn btn-danger btn-sm mr-2 btn-icon"
                            v-if="slotProps.row.item.status === 'APPROVED_FOR_PROJECT'"
                            v-on:click="unapprove(slotProps.row.item)">
                        Unapprove for Project
                    </button>

                    <router-link class="btn btn-sm btn-secondary mr-2 btn-icon"
                                 :to="`/rental/view/${slotProps.row.item.id}`">
                        <b-icon-eye/>
                    </router-link>
                </div>
                <div v-else-if="slotProps.row.field.key === 'company'">
                    {{ getCompanyName(slotProps.row.item) }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'project'">
                    {{ getProjectName(slotProps.row.item) }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'rental_company'">
                    {{ getRentalCompanyName(slotProps.row.item) }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'status'">
                    <rental-status :rental="slotProps.row.item"/>
                </div>
            </template>
        </data-table>
    </div>
</template>

<script>
import Api from '@/providers/Api'

export default {
    name: 'RentalList',
    data () {
        return {
            fields: [
                { key: 'project', sortable: true, label: 'Project' },
                { key: 'rental_company', sortable: true, label: 'Rental Company' },
                { key: 'company', sortable: true, label: 'Company' },
                { key: 'agreement_number', sortable: false, label: 'Agreement Number' },
                { key: 'status', sortable: false, label: 'Status' },
                { key: 'actions', sortable: false, label: 'Actions' },
            ],
            filters: {
                project_id: {
                    field: 'project_id',
                    type: 'multiselect',
                    search: (query) => {
                        return Api.getItems(this, 'project', { name: { field: 'name', value: query } })
                    },
                    apiTable: 'project',
                    labelField: 'name',
                    value: null,
                    label: 'Project'
                },
                company_id: {
                    field: 'company_id',
                    type: 'multiselect',
                    search: (query) => {
                        return Api.getItems(this, 'company', { name: { field: 'name', value: query } })
                    },
                    apiTable: 'company',
                    labelField: 'name',
                    value: null,
                    label: 'Company'
                },
                rental_company_id: {
                    field: 'rental_company_id',
                    type: 'multiselect',
                    search: (query) => {
                        return Api.getItems(this, 'rental-company', { name: { field: 'name', value: query } })
                    },
                    apiTable: 'rental-company',
                    labelField: 'name',
                    value: null,
                    label: 'Rental Company'
                },
                status: {
                    field: 'status',
                    label: 'Status',
                    type: 'select',
                    options: [
                        { value: 'FULLY_APPROVED', text: 'Fully Approved' },
                        { value: 'APPROVED_FOR_PROJECT', text: 'Approved for Project' },
                        { value: 'UNAPPROVED', text: 'Unapproved' },
                    ]
                },
            },
        }
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'rental', this.filters, listParams, ['company', 'project'])
        },
        approve (item) {
            item.approved = true
            this.$api.updateItem(this, 'rental', item).then((response) => {
                this.$refs.dataTable.refresh()
            })
        },
        unapprove (item) {
            item.approved = false
            this.$api.updateItem(this, 'rental', item).then((response) => {
                this.$refs.dataTable.refresh()
            })
        },
        getCompanyName (item) {
            return item.company?.name
        },
        getProjectName (item) {
            return item.project?.name
        },
        getRentalCompanyName (item) {
            return item.rentalCompany?.name
        }
    }
}
</script>

<style scoped>

</style>
